import React, { createContext, useContext, useMemo } from 'react';
import ru from './ru';
import { getUiLocale, uiText } from './uiText';

// Never auto-switch from browser language or translate business data in place.
export const catalogs = {
  ru,
  en: { 'common.save': 'Save', 'common.history': 'History', 'common.loading': 'Loading…', 'common.refresh': 'Refresh' },
  az: { 'common.save': 'Yadda saxla', 'common.history': 'Tarixçə', 'common.loading': 'Yüklənir…', 'common.refresh': 'Yenilə' },
};
export const normalizeLocale = value => Object.hasOwn(catalogs, value) ? value : 'ru';
export function translate(locale, key, values = {}) {
  const message = catalogs[normalizeLocale(locale)][key] ?? (normalizeLocale(locale) === 'az' ? uiText(ru[key] ?? key, {}, 'az') : ru[key] ?? key);
  // Interpolated values are plain React text, never HTML.
  return message.replace(/\{(\w+)\}/g, (match, name) => Object.hasOwn(values, name) ? String(values[name]) : match);
}
export function formatCalendarDate(value, locale = 'ru') {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return value || '—';
  const date = new Date(`${value}T12:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) return value;
  return new Intl.DateTimeFormat(normalizeLocale(locale), { dateStyle: 'medium', timeZone: 'UTC' }).format(date);
}
const defaults = { locale: 'ru', t: (key, values) => translate('ru', key, values) };
const TranslationContext = createContext(defaults);
export function TranslationProvider({ locale = getUiLocale(), children }) {
  const value = useMemo(() => ({ locale: normalizeLocale(locale), t: (key, values) => translate(locale, key, values) }), [locale]);
  return <TranslationContext.Provider value={value}>{children}</TranslationContext.Provider>;
}
export const useTranslation = () => useContext(TranslationContext);
